import type { CellContext, RowData } from '@tanstack/react-table';
import type { JSX, ReactNode } from 'react';
import { DateUtils } from 'ts/commons/DateUtils';

/** Displays a timestamp as a relative date i.e., Now, Today 12:34, Yesterday 23:45 etc. */
export function RelativeDateTimeCell<TData extends RowData, TValue>({
	getValue
}: CellContext<TData, TValue>): ReactNode {
	return DateUtils.formatTimestamp(getValue() as number);
}

/** Displays a timestamp as a full date time value i.e., Nov 10 2023 12:40 and shows the exact timestamp on hover. */
export function DateTimeCell<TData extends RowData, TValue>({ getValue }: CellContext<TData, TValue>): JSX.Element {
	const timestamp = getValue() as number;
	return <span title={String(timestamp)}>{DateUtils.formatDateTime(new Date(timestamp))}</span>;
}

/** Displays a timestamp as a date value i.e., 10.11.2023 and shows the exact timestamp on hover. */
export function DateCell<TData extends RowData, TValue>({ getValue }: CellContext<TData, TValue>): JSX.Element | null {
	const timestamp = getValue() as number;
	if (timestamp <= 0) {
		return null;
	}
	return (
		<span className="text-nowrap" title={DateUtils.formatDateTime(new Date(timestamp))}>
			{DateUtils.formatTimestampToDate(timestamp)}
		</span>
	);
}
